export default __webpack_public_path__ + "static/media/chef-colus-prime.b6a60626.jpg";